import styled from 'styled-components';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'react-router-dom';
import { ListItemAsLinkProps, ListItemTitleTypes, ListItemLabelTypes } from './list-item-types';
import { IconWrapper, Title, LabelSecondary, TitleWrapper } from './base';

export const ListItemIconLeftWrapper = styled(IconWrapper)``;
export const ListItemIconRightWrapper = styled(IconWrapper)``;

const ListItemBadgeWrapper = styled.span``;

const Wrapper = styled.li`
	background-color: var(--list-item-background-color);
	border-radius: var(--sportsbook-rounded-sm);

	&:first-of-type {
		border-top-left-radius: var(--sportsbook-rounded-md);
		border-top-right-radius: var(--sportsbook-rounded-md);
	}
	&:last-of-type {
		margin-bottom: 0;
		border-bottom-left-radius: var(--sportsbook-rounded-md);
		border-bottom-right-radius: var(--sportsbook-rounded-md);
	}

	&:hover {
		${ListItemIconRightWrapper} {
			transform: translateX(5px);
		}
	}
`;

// TODO (navigation) - use router link
const StyledLink = styled(Link)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px;
`;

const StyledTitle = styled(Title)`
	color: var(--sportsbook-list-item-text-color, var(--sportsbook-text-main));
`;

export const ListItemTitle: React.FC<ListItemTitleTypes> = ({ children, className }) => (
	<TitleWrapper>
		<StyledTitle my={1} className={className}>
			{children}
		</StyledTitle>
	</TitleWrapper>
);

export const ListItemLabel: React.FC<ListItemLabelTypes> = ({ children, className }) => (
	<LabelSecondary className={className}>{children}</LabelSecondary>
);

const ListItemAsLink: React.FC<ListItemAsLinkProps> = ({
	onClick,
	children,
	className,
	title,
	iconLeft,
	iconRight,
	badgeElement,
	...linkProps
}) => (
	<Wrapper className={className} onClick={onClick}>
		<StyledLink {...linkProps}>
			{children}
			{iconLeft && <ListItemIconLeftWrapper>{iconLeft}</ListItemIconLeftWrapper>}
			{title && <ListItemTitle>{title}</ListItemTitle>}
			{badgeElement && <ListItemBadgeWrapper>{badgeElement}</ListItemBadgeWrapper>}
			{iconRight && <ListItemIconRightWrapper>{iconRight}</ListItemIconRightWrapper>}
		</StyledLink>
	</Wrapper>
);

export default ListItemAsLink;
